"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _DAO2 = _interopRequireDefault(require("./_DAO"));

var _utils = require("./_utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var InstanceConfig = {};

var ShareContentService = /*#__PURE__*/function (_DAO) {
  (0, _inherits2["default"])(ShareContentService, _DAO);

  var _super = _createSuper(ShareContentService);

  function ShareContentService() {
    (0, _classCallCheck2["default"])(this, ShareContentService);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(ShareContentService, [{
    key: "get",

    /**
     * x-sharing-password: required when accessing a password protected public resource. Base64 encoded.
     * @param {String} resourceUrn
     * @param {Boolean} cdnAcceleration - Whether to return CDN URLs. Note CDN URLs can only be used for read access.
     */
    value: function get(resourceUrn) {
      var cdnAcceleration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var url = "".concat(this._endpoint, "/share/urn/").concat(resourceUrn);
      var params = {
        cdnAcceleration: cdnAcceleration
      };
      var headers = {
        'x-sharing-password': btoa(this.sharingPassword)
      };
      return this.getRequest({
        url: url,
        headers: headers,
        params: params
      });
    }
  }]);
  return ShareContentService;
}(_DAO2["default"]);

var _default = (0, _utils.InstanceCreator)(ShareContentService, InstanceConfig);

exports["default"] = _default;